import { Issue } from '@news-mono/web-common'
import React from 'react'
import { EpaperCollection } from './EpaperCollection'
import { StyledLatestEditionContainer } from './EpaperCollection.styled'
import { StyledLatestEditionHeading } from './LatestEdition.styled'

export interface LatestEditionProps {
    latestEdition: Issue
    allEditions: Issue[]
    onEvent: (event: any) => void
}

export const LatestEdition: React.FC<LatestEditionProps> = (props) => {
    return (
        <>
            <StyledLatestEditionHeading>
                Latest Edition
            </StyledLatestEditionHeading>
            <StyledLatestEditionContainer>
                <EpaperCollection issues={props.allEditions} />
            </StyledLatestEditionContainer>
        </>
    )
}
